import React from "react";


const Portfolio = () => {
  
  const myProjects = [
    {
      projectName: "Restaurant",
      image: "/images/projects/Restaurant.png",
      sourceCodeLink: "https://bitbucket.org/Bhavesh2905/confusion-restaurant/src/master/",
      technology: ["React", "Bootstrap"]
    },
    {
      projectName: "Shopping cart",
      image: "/images/projects/shopping.png",
      sourceCodeLink: "https://bitbucket.org/Bhavesh2905/shopping-cart/src/master/",
      technology: ["React", "Bootstrap"]
    }

  ]
  return (
    <div name="portfolio" className="w-full md:h-screen ">
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">Portfolio</p>
          <p className="py-5">Check out some of my work here...</p>
        </div>
        
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0"> {
          myProjects.map((myProject) => (
            <div className="max-w-sm rounded overflow-hidden shadow-lg">
              <img className="rounded-md duration-200 hover:scale-105 h-65" src={myProject.image} alt={myProject.projectName} />
              <div className="px-6 py-4">
                <div className="font-bold text-xl mb-2">{myProject.projectName}</div>
                
              </div>
              <a href={myProject.sourceCodeLink} target="_blank" rel="noreferrer" className="text-decoration-none">
              <button className="text-white bg-gradient-to-b from-purple-500 to-blue-500 px-3 py-2 my-1 mx-auto flex items-center rounded-md hover:scale-100 duration-150">Source Code</button>
              </a>
              <div class="px-6 pt-4 pb-2">
              {
                  myProject.technology.map((tech)=>(
                    <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">{tech}</span>
                
                
                  ))
                }
                </div>
            </div>
          ))
        }
        </div>
       
        
        {/* Card end */}
      </div>
    </div>
  )
}

export default Portfolio;